import React from 'react';
import { ServiceNames } from '../../../../hoc/constants/service.constants';
import AdherenceService from '../services/adherence';
import { CopayService, FtoService } from '../services';
import { CardProps } from '../services/card/index';

const ServiceFactory: React.FC<CardProps> = ({
	status,
	service,
	data
}) => {
	return (
		<>
			{ service?.name === ServiceNames.adherence &&
				<AdherenceService status={status} service={service} />
			}
			{ (service?.name === ServiceNames.copay && data) &&
				<CopayService status={status} service={service} data={{...data, type: service.name}} />
			}
			{(service?.name === ServiceNames.fto && data) &&
				<FtoService status={status} service={service} data={{...data, type: service.name}} />
			}
		</>
	);
};

export default ServiceFactory;